import React, { useState } from 'react';
import { motion, AnimatePresence, PanInfo } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images: string[] = [
// Playa / paisaje
'https://cdn.magicpatterns.com/uploads/119FwH8CfXVLNUB4oNp5MV/FERNANDO_DE_NORONHA.jpg',
// Submarina
'https://cdn.magicpatterns.com/uploads/xqhDrzH73XCQEYnLZqPt5Q/494be149-27fd-4a05-96fd-6805f2e23ca9.jpg',
// Playa / paisaje
'https://cdn.magicpatterns.com/uploads/1HFGBKXvjGx7SM65bSTc71/GALERIA_NORONHA_7.jpg',
// Submarina
'https://cdn.magicpatterns.com/uploads/7hVmZd3QXZ9CKNuCsPY7nJ/4a822247-1e38-4d3f-a7ff-8e3a951658f5.jpg',
// Playa / paisaje
'https://cdn.magicpatterns.com/uploads/mRFnBqXesNMFdw8sSPxU7X/GALERIA_NORONHA_5.jpg',
// Submarina
'https://cdn.magicpatterns.com/uploads/dSYBYofuAMJCC37QSeaECc/41c0c12f-f628-4e2f-8857-af657ed3923f.jpg',
// Playa / paisaje
'https://cdn.magicpatterns.com/uploads/miSkrBa7rz6wU4Bu7hA34D/GALERIA_NORONHA_3.jpg',
// Submarina
'https://cdn.magicpatterns.com/uploads/1q9QJGjKWLUJW3Bq4fEZcM/b22f7254-8813-4100-bb51-56c37585af80.jpg',
// Playa / paisaje
'https://cdn.magicpatterns.com/uploads/oWZk1TrCsrr8sYvQKLrXYw/GALERIA_NORONHA.jpg',
// Submarina
'https://cdn.magicpatterns.com/uploads/1H7AmB2WWHAwQEDWPQaaux/819f29bd-2def-4700-b625-0bb3e731d3c6.jpg'];
const SWIPE_THRESHOLD = 60;
export function IslandGallery() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const paginate = (dir: number) => {
    setState(([prev]) => {
      const next = (prev + dir + images.length) % images.length;
      return [next, dir];
    });
  };
  const goTo = (target: number) => {
    setState(([prev]) => [target, target > prev ? 1 : -1]);
  };
  const onDragEnd = (_: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    if (info.offset.x < -SWIPE_THRESHOLD) paginate(1);else if (info.offset.x > SWIPE_THRESHOLD) paginate(-1);
  };
  return <section className="relative bg-noronha-volcanic py-24 md:py-32 overflow-hidden" data-id="element-311">
      <div className="container mx-auto px-6" data-id="element-312">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-2xl mx-auto text-center mb-12 md:mb-16" data-id="element-313">
          <span className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-noronha-gold block mb-4" data-id="element-314">
            La isla en imágenes
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-noronha-text-heading tracking-tight text-balance" data-id="element-315">
            Descubrí Fernando de Noronha
          </h2>
        </motion.div>

        {/* Gallery */}
        <div className="max-w-4xl mx-auto" data-id="element-316">
          <div className="relative" data-id="element-317">
            {/* Image stage */}
            <div className="relative aspect-[4/3] md:aspect-[16/10] rounded-3xl overflow-hidden bg-noronha-graphite border border-noronha-petroleum/30 shadow-[0_24px_60px_rgba(2,6,23,0.45)]" data-id="element-318">
              <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-319">
                <motion.img key={index} src={images[index]} alt={`Fernando de Noronha — imagen ${index + 1}`} custom={direction} draggable={false} initial={{
                opacity: 0,
                x: direction > 0 ? 60 : -60
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction > 0 ? -60 : 60
              }} transition={{
                opacity: {
                  duration: 0.4,
                  ease: 'easeInOut'
                },
                x: {
                  duration: 0.45,
                  ease: [0.25, 0.1, 0.25, 1]
                }
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.18} onDragEnd={onDragEnd} className="absolute inset-0 w-full h-full object-cover cursor-grab active:cursor-grabbing" data-id="element-320" />
              </AnimatePresence>
            </div>

            {/* Arrows (desktop) */}
            <button onClick={() => paginate(-1)} aria-label="Imagen anterior" className="hidden md:flex absolute top-1/2 -translate-y-1/2 -left-5 w-12 h-12 items-center justify-center rounded-full bg-noronha-volcanic/80 backdrop-blur border border-noronha-petroleum/50 text-noronha-text-heading hover:border-noronha-emerald hover:text-noronha-emerald transition-all duration-300" data-id="element-321">
              <ChevronLeft className="w-5 h-5" data-id="element-322" />
            </button>
            <button onClick={() => paginate(1)} aria-label="Imagen siguiente" className="hidden md:flex absolute top-1/2 -translate-y-1/2 -right-5 w-12 h-12 items-center justify-center rounded-full bg-noronha-volcanic/80 backdrop-blur border border-noronha-petroleum/50 text-noronha-text-heading hover:border-noronha-emerald hover:text-noronha-emerald transition-all duration-300" data-id="element-323">
              <ChevronRight className="w-5 h-5" data-id="element-324" />
            </button>
          </div>

          {/* Dot indicators */}
          <div className="flex items-center justify-center gap-2.5 mt-7" role="tablist" aria-label="Navegación de la galería" data-id="element-325">
            {images.map((_, i) => <button key={i} onClick={() => goTo(i)} role="tab" aria-selected={i === index} aria-label={`Ir a la imagen ${i + 1}`} className={`h-2 rounded-full transition-all duration-300 ${i === index ? 'w-7 bg-noronha-emerald' : 'w-2 bg-noronha-petroleum/60 hover:bg-noronha-petroleum'}`} data-id="element-326" />)}
          </div>
        </div>
      </div>
    </section>;
}